import { Check, Clock } from "lucide-react";

const working = [
  "Register multiple brands and bind each to its own Google Ads (sub-)account",
  "Auto-scrape your homepage into a 9-section value-prop doc",
  "Connect any Google Ads account via OAuth — MCC and sub-accounts supported",
  "Pull real Keyword Planner data and filter against your target CPA",
  "Theme keywords into ad groups and write RSA copy from your value-prop doc",
  "Generate negative-keyword lists (off-vertical, informational, competitor)",
  "Geo-target below country level — city, region, radius",
  "Publish campaigns to Google Ads as paused (you flip the switch)",
  "Edit live campaigns by chat — pause, resume, budget, negatives",
  "Lifetime and date-ranged reporting across all your brands",
];

const coming = [
  "Conversion tracking setup (today: bring your own via GA4 / GTM)",
  "Performance Max, Display, YouTube and Shopping (today: Search only)",
  "Manual bid adjustments (today: Google Smart Bidding handles this)",
  "A/B test management for ad copy",
];

const McpCapabilities = () => {
  return (
    <section className="py-20 px-4 bg-background border-b border-border">
      <div className="container mx-auto max-w-5xl">
        <div className="text-center max-w-2xl mx-auto mb-14">
          <h2 className="text-3xl md:text-4xl font-bold text-foreground">
            What's in the box today
          </h2>
          <p className="mt-4 text-lg text-muted-foreground">
            We're early and we'd rather be honest than oversell. Here's exactly
            what works right now, and what's on the roadmap.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <div className="rounded-lg border border-border bg-card text-card-foreground p-6">
            <div className="flex items-center gap-2 mb-4">
              <div className="h-8 w-8 rounded-md bg-primary/10 text-primary flex items-center justify-center">
                <Check className="h-4 w-4" />
              </div>
              <h3 className="font-semibold text-lg">Working today</h3>
            </div>
            <ul className="space-y-3">
              {working.map((item) => (
                <li key={item} className="flex items-start gap-2 text-sm">
                  <Check className="h-4 w-4 text-primary mt-0.5 shrink-0" />
                  <span className="text-foreground">{item}</span>
                </li>
              ))}
            </ul>
          </div>

          <div className="rounded-lg border border-border bg-card text-card-foreground p-6">
            <div className="flex items-center gap-2 mb-4">
              <div className="h-8 w-8 rounded-md bg-muted text-muted-foreground flex items-center justify-center">
                <Clock className="h-4 w-4" />
              </div>
              <h3 className="font-semibold text-lg">Not yet (on the roadmap)</h3>
            </div>
            <ul className="space-y-3">
              {coming.map((item) => (
                <li key={item} className="flex items-start gap-2 text-sm">
                  <Clock className="h-4 w-4 text-muted-foreground mt-0.5 shrink-0" />
                  <span className="text-muted-foreground">{item}</span>
                </li>
              ))}
            </ul>
            <p className="mt-6 text-xs text-muted-foreground">
              Need one of these soon? Email{" "}
              <a
                href="mailto:george@upfixe.com"
                className="text-primary hover:underline"
              >
                george@upfixe.com
              </a>{" "}
              — founder ships fast for early users.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default McpCapabilities;
